function match(scales, programCode, partnerCode, typeId, localOnly) {
    let result = null;

    scales.forEach((gs) => {
        if (Number(gs.grading_scale_type_id) !== Number(typeId)) return;
        if (!Array.isArray(gs.program_code) || !gs.program_code.includes(programCode)) return;

        const restricted   = Array.isArray(gs.partner_code) && gs.partner_code.length > 0;
        const partnerMatch = restricted && gs.partner_code.includes(partnerCode);

        if (localOnly) {
            if (partnerMatch && !result) result = gs;
            return;
        }
        if (restricted && partnerMatch) result = gs;
        else if (!restricted && !result) result = gs;
    });

    return result;
}

export default {
    resolve(scales, { programCode, partnerCode = null, typeId = null, defaultTypeId }) {
        const effective = typeId || defaultTypeId;
        return (
            match(scales, programCode, partnerCode, effective, false) ||
            (effective !== defaultTypeId ? match(scales, programCode, partnerCode, defaultTypeId, false) : null)
        );
    },
    resolveLocal(scales, { programCode, partnerCode = null, typeId = null, defaultTypeId }) {
        const effective = typeId || defaultTypeId;
        return (
            match(scales, programCode, partnerCode, effective, true) ||
            (effective !== defaultTypeId ? match(scales, programCode, partnerCode, defaultTypeId, true) : null)
        );
    },
};